/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
import {
  CommerceSale,
  CommerceStore,
  StoresTicketSalesPageLayoutFragment,
  TabularMenuFragment,
  WebPage,
} from '@ts/operations'
import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react'

import { ProductProps } from './StoresSaleProductList'

type StoresSaleContextType = {
  activeTabIndex: number
  categoriesMenu?: TabularMenuFragment
  countdownSales?: Array<CommerceSale>
  currentCountdownSale?: CommerceSale
  currentReleasePhaseSale?: CommerceSale
  releasePhaseSales?: Array<CommerceSale>
  setActiveTabIndex?: (e: number) => void
  store?: CommerceStore
  tabs?: Array<TabProps>
}
export type TabProps = {
  benefitsList?: StoresTicketSalesPageLayoutFragment['benefitsList'] | null
  categoriesMenu?: TabularMenuFragment | null
  countdownTimer?: Array<CommerceSale>
  path: string
  products?: Array<ProductProps>
  releasePhaseStepper?: Array<CommerceSale>
  webPage: WebPage
}
const StoresSaleContext = createContext<StoresSaleContextType>({
  activeTabIndex: 0,
})
const StoresSaleContextProvider = ({
  children,
  tabs,
  store,
  defaultTabIndex,
  categoriesMenu,
}: {
  categoriesMenu?: TabularMenuFragment
  children: ReactNode
  defaultTabIndex: number
  store: CommerceStore
  tabs?: Array<TabProps>
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(defaultTabIndex || 0)
  const activeTab = tabs?.[activeTabIndex]
  const today = new Date()
  const currentCountdownSale = activeTab?.countdownTimer?.find(
    sale => new Date(sale?.startDate) <= today && today < new Date(sale?.endDate)
  )
  const currentReleasePhaseSale = activeTab?.releasePhaseStepper?.find(
    sale => new Date(sale?.startDate) <= today && today < new Date(sale?.endDate)
  )

  useEffect(() => {
    setActiveTabIndex(defaultTabIndex)
  }, [defaultTabIndex])
  return (
    <StoresSaleContext.Provider
      value={{
        activeTabIndex,
        categoriesMenu,
        countdownSales: activeTab?.countdownTimer,
        currentCountdownSale,
        currentReleasePhaseSale,
        releasePhaseSales: activeTab?.releasePhaseStepper,
        setActiveTabIndex,
        store,
        tabs,
      }}
    >
      {children}
    </StoresSaleContext.Provider>
  )
}
export const useStoresSaleContext = () => useContext(StoresSaleContext)

export default StoresSaleContextProvider
